export const defaultLocale = "en" as const;
export const locales = [
  "cs",
  "da",
  "de",
  "en",
  "es",
  "fr",
  "it",
  "hu",
  "nl",
  "no",
  "pl",
  "pt",
  "ro",
  "sr",
  "fi",
  "sv",
  "tr",
  "bg",
  "ru",
  "uk",
] as const;
export type Locale = (typeof locales)[number];

// Kullanıcıya AÇIK diller. `locales` çevirisi repoda duran her dildir (mesaj
// dosyaları, denetim, tarih biçimi); kapalı bir dil silinmez ama hiçbir yerde
// seçilemez: dil seçicide görünmez, cookie'de/`?lang=`'da/IP tahmininde gelse
// İngilizceye iner. Açmak = buraya bir satır. ⚠️ backend/locales.py →
// ACTIVE_LOCALES, landing ACTIVE_LANGS ve admin ACTIVE_EMAIL_LOCALES ile elle senkron.
export const activeLocales = ["en", "tr"] as const satisfies readonly Locale[];
export type ActiveLocale = (typeof activeLocales)[number];

export function isActiveLocale(raw: string | null | undefined): raw is ActiveLocale {
  return (activeLocales as readonly string[]).includes(raw ?? "");
}

export const localeNames: Record<Locale, string> = {
  cs: "Čeština",
  da: "Dansk",
  de: "Deutsch",
  en: "English",
  es: "Español",
  fr: "Français",
  it: "Italiano",
  hu: "Magyar",
  nl: "Nederlands",
  no: "Norsk",
  pl: "Polski",
  pt: "Português",
  ro: "Română",
  sr: "Srpski",
  fi: "Suomi",
  sv: "Svenska",
  tr: "Türkçe",
  bg: "Български",
  ru: "Русский",
  uk: "Українська",
};

// Intl date/number formatting tag per UI locale. Kept here (not inlined at each
// call site) so adding a locale never leaves a screen silently formatting dates
// in English while the rest of the page is translated.
export const intlLocales: Record<Locale, string> = {
  cs: "cs-CZ",
  da: "da-DK",
  de: "de-DE",
  en: "en-US",
  es: "es-ES",
  fr: "fr-FR",
  it: "it-IT",
  hu: "hu-HU",
  nl: "nl-NL",
  no: "nb-NO",
  pl: "pl-PL",
  pt: "pt-PT",
  ro: "ro-RO",
  sr: "sr-Latn-RS",
  fi: "fi-FI",
  sv: "sv-SE",
  tr: "tr-TR",
  bg: "bg-BG",
  ru: "ru-RU",
  uk: "uk-UA",
};

export function intlLocale(raw: string | null | undefined): string {
  return intlLocales[raw as Locale] ?? intlLocales.en;
}
